<script setup lang="ts">
import { ref, onMounted, computed } from "vue";
import { trans } from "laravel-vue-i18n";
import { format, parse } from "fecha";
import { useAuthStore } from "@/ts/stores/auth";

const component = ref<HTMLDivElement>();
const authStore = useAuthStore();

const emit = defineEmits(["mounted"]);

onMounted(() => {
    emit("mounted", component.value!.offsetHeight);

    onMounted(() => {
        window.addEventListener("resize", () => {
            emit("mounted", component.value!.offsetHeight);
        });

        window.addEventListener("orientationchange", () => {
            emit("mounted", component.value!.offsetHeight);
        });
    });
});

const daysLeft = computed(() => {
    const today = new Date();
    const Difference_In_Time = parse(authStore.user!.membership_end_date, "DD/MM/YYYY")!.getTime() - today.getTime();
    const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
    return Math.ceil(Difference_In_Days);
});
</script>

<template>
    <div ref="component" class="w-full flex flex-col items-center px-4 pt-10 pb-4 md:p-10 lg:px-[6.625rem] lg:py-[3.75rem]">
        <h2 class="mb-4 text-center font-heading text-40 font-[690] uppercase [font-stretch:_190%] md:mb-4 lg:text-48">Tot ziens, {{ authStore.user.first_name }}!</h2>
        <p class="mb-6 text-center">Je lidmaatschap verloopt binnen {{ daysLeft }} dag{{ daysLeft > 1 ? "en" : "" }} op {{ authStore.user.membership_end_date }} en wordt niet verlengd.</p>
        <p class="mb-6 text-center">Je hebt een mailtje ontvangen met de bevestiging van je opzeg.</p>
        <p class="mb-10 text-center">Tot in de toekomst?</p>
        <a href="/" class="btn btn-black">
            Naar hajee.be
            <svg-vue icon="arrow" class="ml-[.625rem] h-6 w-auto"></svg-vue>
        </a>
    </div>
</template>
